
import Vue from "vue";
import Appsettings from "@/config/appsettings.json";
import Documents from "@/config/documents.json";
import UnAuthMenuBar from "@/components/UnAuthMenuBar.vue";
import SocialMedia from "@/config/social-media.json";
import DisableWarehouse from "@/components/DisableWarehouse.vue";

export default Vue.extend({
  name: "Landing",
  components: {
    UnAuthMenuBar,
    DisableWarehouse
  },
  data() {
    return {
      signUpPage: "Signup",
      orderBarrel: "Order",
      socialMedia: SocialMedia,
    };
  },
  computed: {
    termsAndConditionsPath() {
      return `https://${Appsettings.StaticResourcePath}/${Documents.termsAndConditionsPath}`;
    },
    applicationPolicyPath() {
      return `https://${Appsettings.StaticResourcePath}/${Documents.applicationPolicyPath}`;
    },
    disableWarehouse() {
      return Appsettings.DisableWarehouse ?? false;
    }
  },
  methods: {
    signUp() {
      this.$router.push({ name: this.signUpPage });
    },
    startPackYuhBarrel() {
      if(this.disableWarehouse){
        return;
      }
      this.$router.push({ name: this.orderBarrel });
    },
  },
});
